import type { BillingCycle, ServiceDto } from '@fos/shared/contracts/services';
import { BILLING_CYCLE_SUFFIX } from '@fos/shared/labels';
import { formatDate, formatMoneyAuto } from '../../lib/format';

/** Cena z cyklem: „490 zł / mies.”, „1 990 zł / rok”; bez ceny (albo bez „Widzi stawki i kwoty”) → null. */
export function servicePriceText(service: Pick<ServiceDto, 'price' | 'cycle'> & { currency?: string }): string | null {
  if (service.price === undefined || service.price === null) return null;
  const suffix = BILLING_CYCLE_SUFFIX[service.cycle];
  const text = formatMoneyAuto(service.price, service.currency);
  return suffix ? `${text} ${suffix}` : text;
}

/** „Co rok” → „odnawia się co rok”; jednorazowo / inny cykl → opis bez odnowienia. */
const RENEWS: Record<BillingCycle, string> = {
  year: 'odnawia się co rok',
  quarter: 'odnawia się co kwartał',
  month: 'odnawia się co miesiąc',
  other: 'odnowienie według ustaleń',
  none: 'jednorazowo',
};

/** „16.10.2025, odnawia się co rok” (Figma: karta zasobu → Ustalenia → Od). */
export function serviceSinceText(service: Pick<ServiceDto, 'periodStart' | 'cycle'>): string | null {
  if (!service.periodStart) return null;
  return `${formatDate(service.periodStart)}, ${RENEWS[service.cycle]}`;
}
